export function call(name, params = {}, context = {}) {
  return new Promise((resolve, reject) => {
    $.evo.io().call(name, params, context, (err, data) => {
      if(err) {
        return reject(err);
      }

      return resolve(data);
    })
  });
}